import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {
    FALLBACK_LANGUAGE,
    LANGUAGE_STORAGE_KEY,
    SUPPORTED_LANGUAGE_CODES,
    normalizeLanguage,
} from "./language";

export const getInitialLanguage = () => {
    if (typeof window === "undefined") {
        return FALLBACK_LANGUAGE;
    }

    const storedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);

    return normalizeLanguage(storedLanguage || FALLBACK_LANGUAGE);
};

const syncLanguageStorage = (i18nInstance, initialLanguage) => {
    if (typeof window === "undefined") {
        return;
    }

    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, initialLanguage);

    if (!i18nInstance.__languageStorageListener) {
        i18nInstance.on("languageChanged", (language) => {
            window.localStorage.setItem(
                LANGUAGE_STORAGE_KEY,
                normalizeLanguage(language)
            );
        });
        i18nInstance.__languageStorageListener = true;
    }
};

const addResourceBundles = (i18nInstance, resources) => {
    Object.entries(resources).forEach(([language, resource]) => {
        i18nInstance.addResourceBundle(
            language,
            "translation",
            resource.translation || {},
            true,
            true
        );
    });
};

const initI18n = (resources, options = {}) => {
    const initialLanguage = normalizeLanguage(
        options.language || getInitialLanguage()
    );

    if (!i18n.isInitialized) {
        i18n.use(initReactI18next).init({
            resources,
            lng: initialLanguage,
            fallbackLng: FALLBACK_LANGUAGE,
            supportedLngs: SUPPORTED_LANGUAGE_CODES,
            interpolation: {
                escapeValue: false,
            },
            react: {
                useSuspense: false,
            },
            ...options.i18nOptions,
        });
    } else {
        addResourceBundles(i18n, resources);
        i18n.changeLanguage(
            normalizeLanguage(i18n.resolvedLanguage || i18n.language)
        );
    }

    syncLanguageStorage(i18n, initialLanguage);

    return i18n;
};

export default initI18n;
